import React, { Component } from "react";
import LocalizedStrings from "react-localization";
import en from "../localization/localization-en.json";
import { Link } from "react-router-dom";
import YaystackNavBar from "../components/yaystackNavBar.jsx";

let strings = new LocalizedStrings({ en });
class ErrorPage extends Component {
  state = {};
  render() {
    // Render Waiting Website
    // {/* <div className="center"> */}
    //   {/* <h4 className="mt-5 mb-5">{strings.pages_does_not_exist}</h4> */}
    //   {/* <Link to="/">
    //     <button className="btn btn-primary btn_yaystack">
    //       {strings.return_home}
    //     </button>
    //   </Link> */}
    // {/* </div> */}
    return (
      <React.Fragment>
        <YaystackNavBar />
        <div className="profilePage list center">
          <div style={{ marginTop: 100 }} />
          <div className="max_width_500">
            <div className="list_user " style={{ backgroundColor: "white" }}>
              <div>
                <label
                  className="number_questions"
                  style={{
                    display: "block",
                    marginBottom: "0px",
                    color: "#9B9B9B"
                  }}
                >
                  We Are Coming Soon to
                </label>
                <label
                  className="name"
                  style={{
                    paddingBottom: "5px",
                    lineHeight: "30px",
                    color: "#ff5116"
                  }}
                >
                  Elevate Remarkable Brands
                </label>
                {/* <div style={{ marginTop: 0 }}>
                  <label
                    className="number_questions"
                    style={{
                      display: "block",
                      marginBottom: "0px",
                      color: "#9B9B9B"
                    }}
                  >
                    Join Beta Group By Sending Name And Email At{" "}
                    <a href="mailto:trey@yaystack.co?subject=Beta Access">
                      dev@yaystack.co
                    </a>
                  </label>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/pages/404.jsx